import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";

type AlertTone = "success" | "warning" | "danger";

interface AlertItem {
  title: string;
  description: string;
  tone: AlertTone;
}

const iconMap = {
  success: <CheckCircleOutlineOutlinedIcon fontSize="small" />,
  warning: <WarningAmberOutlinedIcon fontSize="small" />,
  danger: <ErrorOutlineOutlinedIcon fontSize="small" />,
};

const colorMap = {
  success: { bg: "#F4FBF6", border: "#D7EFDF", color: "#1E8449" },
  info: { bg: "#F3F8FC", border: "#CFE3F4", color: "#2471A3" },
  warning: { bg: "#FFF9F1", border: "#F5D9A6", color: "#9A6708" },
  danger: { bg: "#FEF4F3", border: "#F2C6C2", color: "#A93226" },
};

export default function AlertList({ items }: { items: AlertItem[] }) {
  return (
    <Stack spacing={1.25}>
      {items.map((item, idx) => {
        const c = colorMap[item.tone];
        return (
          <Box
            key={idx}
            sx={{
              p: 1.5,
              borderRadius: "10px",
              bgcolor: c.bg,
              border: `1px solid ${c.border}`,
            }}
          >
            <Stack direction="row" spacing={1.25} alignItems="flex-start">
              <Box sx={{ color: c.color, mt: 0.25 }}>{iconMap[item.tone]}</Box>
              <Box>
                <Typography sx={{ fontSize: 13, fontWeight: 800, color: "#17324D" }}>
                  {item.title}
                </Typography>
                <Typography sx={{ fontSize: 13, color: "#66788A", mt: 0.25, lineHeight: 1.6 }}>
                  {item.description}
                </Typography>
              </Box>
            </Stack>
          </Box>
        );
      })}
    </Stack>
  );
}
